<div class="page-not-found">
    <div class="text">
        <span>Page not found</span>
    </div>
    <div class="action">
        <button mat-button (click)="goHome()">Go home</button>
    </div>
</div>